<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres titulo="Trocar Senha" :voltar="true" breakpoint="xl" />
    </template>
    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(salvar)">
        <h6 class="m-3">
          Escolha uma nova senha, que será utilizada para acessar o Portal do
          TCE de agora em diante.<br />
          <span v-if="user?.NOME">{{ user?.NOME }}</span>
        </h6>
        <b-row v-if="user" class="m-3">
          <b-col cols="12" lg="6">
            <default-form-validation-provider
              label="CPF"
              v-slot="defaultState"
              rules=""
            >
              <b-form-input
                v-model="user.CPF"
                :state="defaultState.state"
                type="number"
                disabled
              />
            </default-form-validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <default-form-validation-provider
              label="Senha atual"
              v-slot="defaultState"
            >
              <b-form-input
                v-model="atualSenha"
                :state="defaultState.state"
                type="password"
                autocomplete="current-password"
              />
            </default-form-validation-provider>
          </b-col>
        </b-row>

        <b-row class="m-3">
          <b-col cols="12" lg="6">
            <default-form-validation-provider label="Nova senha">
              <b-form-input
                v-model="novaSenhaPrimeira"
                :state="senhaState"
                type="password"
                autocomplete="new-password"
              />
            </default-form-validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <default-form-validation-provider label="Confirmação da nova senha">
              <b-form-input
                v-model="novaSenhaConfirmacao"
                :state="senhaState"
                type="password"
                autocomplete="new-password"
              />
              <b-form-invalid-feedback v-if="senhaState === false">
                {{ mensagem }}
              </b-form-invalid-feedback>
              <b-form-valid-feedback v-if="senhaState === true">
                As senhas coincidem.
              </b-form-valid-feedback>
            </default-form-validation-provider>
          </b-col>
        </b-row>
        <h6 class="mb-3">
          <b-button
            class="float-center m-1"
            size="sm"
            type="submit"
            :disabled="!senhaState"
          >
            <font-awesome-icon icon="save" />
            Salvar
          </b-button>
        </h6>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script lang="ts">
import { Component, Ref, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { store } from "@/store";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";
import { DatePickerDefaultProps } from "@/types/form-default-props";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { Usuario } from "@/types/administracao/usuarios/usuario";
import usuarioService from "@/services/administracao/usuarioService";
import { MudancaSenha } from "@/types/administracao/mudanca-senha";
import { PortalError } from "@/types/portal-error";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";

const CompProps = Vue.extend({
  name: "TrocarSenha",
  components: {
    DefaultFormValidationProvider,
    ValidationObserver,
    HeaderSagres,
  },
});

@Component
export default class TrocarSenha extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  user: Usuario | null = null;
  atualSenha: string | null = null;
  novaSenhaPrimeira: string | null = null;
  novaSenhaConfirmacao: string | null = null;
  datePickerProps = DatePickerDefaultProps;
  mensagem: string | null = null;

  async mounted() {
    try {
      this.user = await this.meuPerfil();
    } catch (e: any) {
      this.$toast.error("Problema ao montar o componente");
      console.error("Problema ao montar o componente TrocarSenha", e);
    } finally {
      store.blockScreen = false;
    }
  }

  get senhaState(): boolean | null {
    if (!this.novaSenhaConfirmacao || !this.novaSenhaPrimeira) return null;
    if (
      this.novaSenhaConfirmacao.length < 6 ||
      this.novaSenhaPrimeira.length < 6
    ) {
      this.mensagem = "Senha com no mínimo 6 caracteres.";
      return false;
    } else if (this.novaSenhaConfirmacao !== this.novaSenhaPrimeira) {
      this.mensagem = "As senhas não coincidem.";
      return false;
    } else if (
      this.novaSenhaConfirmacao === this.novaSenhaPrimeira &&
      this.novaSenhaPrimeira === this.atualSenha
    ) {
      this.mensagem = "A nova senha não pode ser igual a senha atual.";
      return false;
    }
    return true;
  }

  async meuPerfil(): Promise<Usuario | null> {
    const meuPerf = await usuarioService.meuPerfil();
    if (meuPerf) return meuPerf;
    this.$toast.error("Erro ao obter usuário");
    return null;
  }

  async salvar(): Promise<any> {
    store.blockScreen = true;
    try {
      const isValid = await this.validationobserver.validate();
      if (!isValid) return console.error(this.validationobserver);
      const senhasObj = new MudancaSenha();
      if (this.atualSenha) senhasObj.senhaAtual = this.atualSenha;
      if (this.novaSenhaConfirmacao)
        senhasObj.senhaNova = this.novaSenhaConfirmacao;
      const response = await usuarioService.trocarSenha(senhasObj);
      if (response) return this.$toast.success(`Senha atualizada com sucesso!`);
    } catch (e: any) {
      this.$toast.error(
        `Não foi possível atualizar a senha!\n${e.response.data.message ?? ""}`
      );
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>

<style scoped></style>
